import angular from 'angular';

export const AjustesPontoListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        $stateProvider
            .state('ajustesponto', {
            url: '/ponto/ajustes?tab',
            template: require('html-loader!./index/ajustesponto.index.html'),
            controller: 'AjustesPontoIndexController',
            controllerAs: 'ajstpt_cntrllr',
        });
    }
];
